module.exports = __webpack_public_path__ + "img/NorwayWhite.21ca1a4d.svg";